import { createContext } from 'react';

const ConfigurationContext = createContext();

export default ConfigurationContext;
